import { Component, Input, OnInit, EventEmitter, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-on-lista',
  templateUrl: './on-lista.component.html',
  styleUrls: ['./on-lista.component.scss']
})
export class OnListaComponent implements OnInit {

    private _objSession = {key: 'onLista', severity: 'error', summary: 'Sesión Expirada', detail: 'Lo vamos a redirigir para volver a ingresar'};
    private _routerLogout = ['auth','logout'];

    @ViewChild('dt', {static: false}) dt!: any;

    @Input() title: string;
    @Input() show: boolean = false;
    @Input() items: Record<string, any>[] = [];
    @Input() columns: Record<string, any>[] = [];
    @Input() recordName: string;
    @Input() service: any;
    @Input() objClass: any;
    @Input() totalRecords: number = 0;
    @Input() filters: Record<string, any>[] = []

    @Output() close = new EventEmitter();

    selectedItems: Record<string, any>[];
    rowsPerPageOptions = [10];
    filterValue: string;
    loading: boolean = false;

    constructor( private messageService: MessageService, private router: Router ) {
    }

    ngOnInit(): void {
        this.searchFilterData();
    }

    // para hacer el llamodo a los servicios y completar la lista
    ngOnChanges(changes: SimpleChanges): void {
        if ( changes?.service?.currentValue ) {
            this.onItems();
        }
        this.searchFilterData();
    }

    async searchFilterData() {
        const stateStr = sessionStorage.getItem(this.recordName);
        if (stateStr) {
            const state = JSON.parse(stateStr);
            if ( state ) {
                this.filterValue = state?.filters?.global?.value;
                this.filterData(this.filterValue);
                // this.filterValueTemp = state?.globalFilter
            }
        }
    }

    async onHide( obj?: any ) {
        this.close.emit( obj );
    }

    // recuperar la lista de articulos
    async onItems( event?: any ) {
        if ( this.service ) {
            try {
                this.loading = true;
                if ( this.recordName ) { await this.setSessionStorage(event) };
                const res = await this.service.getAll(null, { filters: this.filters });
                if ( res.ok ) {
                    this.items = res.resp.rows;
                    this.totalRecords = res.resp.count;
                } else {
                    this.messageService.add({key: 'onLista', severity: 'error', summary: res.msg, detail: res.resp});
                }
                // console.log(event);
                if ( event ) { event.globalFilter = null };
                if ( this.recordName ) { await this.setSessionStorage(event) };
                this.loading = false;
            } catch (error: any) {
                if ( error?.status === 401 ) {
                    this.messageService.add( this._objSession );
                    setTimeout( () => { this.router.navigate(this._routerLogout) }, 4000);
                }
                this.messageService.add({key: 'onLista', severity: 'error', summary: 'Error', detail: error.message})
            }
        }
    }

    async setSessionStorage( e?: any ) {
        if ( e ) {
            sessionStorage.setItem(this.recordName, JSON.stringify(e));
            sessionStorage.setItem(`${this.recordName}1`, JSON.stringify(e));
        }
    }

    async onClick( obj: any ) {
        this.onHide( obj );
    }

    filterData(target: any, blur?: boolean): void {
        this.dt?.filterGlobal(target?.value, 'contains');
    }

    onChangeBuscar() {
        if ( this.filterValue.length == 0 ) {
            this.onItems();
        }
    }

    getOptionLabel( options: any[], field: any ) {     
        let label = '';
        if ( options ) {
            for (const option of options) {
                if ( option.valor === field ) {
                    label = option.nombre;
                }
            }
        }
        return label;
    }


}
